import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
const View = {template: '<router-view></router-view>'}

export default new Router({
    routes: [
        {
            path: "/",
            redirect: "/dashboard",
            component: () => import("./core/plugins/TitleRibbon/index"),
            // component: () => import("./core/plugins/TerminalDashboard/index"),
            children: [
                {
                    path: "/dashboard",
                    name: "dashboard",
                    meta: {main_page: true},
                    component: () => import("./core/plugins/TitleRibbon/Dashboard"),
                    // component: () => import("./core/plugins/TerminalDashboard/Dashboard")
                },

                {
                    path: "/logo",
                    name: "logo.index",
                    component: () => import("@/view/pages/site/index"),
                    meta: {title: "سفارش لوگو", has_ribbon: true,},
                },
                {
                    path: "/office/set",
                    name: "officeSet.index",
                    component: () => import("@/view/pages/site/office/officeForm"),
                    meta: {title: "سفارش ست اداری", has_ribbon: true,},
                },
                {
                    path: "/visit/card",
                    name: "visit.index",
                    component: () => import("@/view/pages/site/seo"),
                    meta: {title: "سفارش کارت ویزیت", has_ribbon: true,},
                },
                {
                    path: "/header",
                    name: "headerForm.index",
                    component: () => import("@/view/pages/site/office/headerForm"),
                    meta: {title: "سفارش سربرگ", has_ribbon: true,},
                },
                {
                    path: "/banner",
                    name: "banner.index",
                    component: () => import("@/view/pages/site/banner/bannerForm"),
                    meta: {title: "سفارش بنر", has_ribbon: true,},
                },
                {
                    path: "/poster",
                    name: "poster.index",
                    component: () => import("@/view/pages/site/poster/posterForm"),
                    meta: {title: "سفارش پوستر", has_ribbon: true,},
                },
                {
                    path: "/brochur",
                    name: "brochur.index",
                    component: () => import("@/view/pages/site/brochur/brochurForm"),
                    meta: {title: "سفارش بروشور", has_ribbon: true,},
                },

                {
                    path: "/support",
                    name: "support.index",
                    component: () => import("@/view/pages/site/support"),
                    meta: {title: "سفارش پشتیبانی سایت", has_ribbon: true,},
                },
                {
                    path: "/tracet",
                    name: "tracet.index",
                    component: () => import("@/view/pages/site/tracet/tracetPage"),
                    meta: {title: "طراحی تراکت", has_ribbon: true,},
                },
                {
                    path: "/user/all",
                    name: "all.index",
                    component: () => import("@/view/pages/site/userAllRequest.vue"),
                    meta: {title: "لیست سفارش های من", has_ribbon: true,},
                },

                {
                    path: "/site/:id",
                    name: "site.edit",
                    props: true,
                    component: () => import("@/view/pages/site/Edit"),
                    meta: {title: "اصلاح سفارش سایت", has_ribbon: true},
                },
                {
                    path: "/profile",
                    name: "profile",
                    component: () => import("@/view/pages/profile/Profile.vue"),
                    children: [
                        {
                            path: "my-profile",
                            name: "myProfile",
                            component: () => import("@/view/pages/profile/MyProfile.vue")
                        },
                    ]
                },
                {
                    path: "/tarefe",
                    name: "tarefe.list",
                    component: () => import("@/view/pages/tarefe/list"),
                    meta: {title: "لیست تعرفه ها", has_ribbon: true},
                },
                {
                    path: "/tarefe/create",
                    name: "tarefe.create",
                    component: () => import("@/view/pages/tarefe/create"),
                    meta: {title: "ایجاد تعرفه", has_ribbon: true},
                },
                {
                    path: "/admin/forms",
                    name: "admin.index",
                    component: () => import("@/view/pages/admin/requestsList"),
                    meta: {title: "لیست سفارش ها", has_ribbon: true,},
                },
                {
                    path: "/orders/all",
                    name: "allOrder",
                    component: () => import("@/view/pages/site/allOrders.vue"),
                    meta: {title: "لیست سفارش های من", has_ribbon: true},
                },

            ]
        },

        {
            path: "/",
            redirect: "/dashboard",
            component: () => import("@/view/layout/Layout"),
            children: [
                {
                    path: "/dashboard",
                    name: "dashboard",
                    component: () => import("@/view/pages/Dashboard.vue")
                },
                {
                    path: "/profile",
                    name: "profile",
                    component: () => import("@/view/pages/profile/Profile.vue"),
                    children: [
                        {
                            path: "my-profile",
                            name: "myProfile",
                            component: () => import("@/view/pages/profile/MyProfile.vue")
                        },
                    ]
                },
            ]
        },


        //  ERRORS
        {
            path: "/custom-error",
            name: "error",
            component: () => import("@/view/pages/error/Error.vue"),
            children: [
                {
                    path: "error-1",
                    name: "error-1",
                    component: () => import("@/view/pages/error/Error-1.vue")
                },
                {
                    path: "error-2",
                    name: "error-2",
                    component: () => import("@/view/pages/error/Error-2.vue")
                },
                {
                    path: "error-3",
                    name: "error-3",
                    component: () => import("@/view/pages/error/Error-3.vue")
                },
                {
                    path: "error-4",
                    name: "error-4",
                    component: () => import("@/view/pages/error/Error-4.vue")
                },
                {
                    path: "error-5",
                    name: "error-5",
                    component: () => import("@/view/pages/error/Error-5.vue")
                },
                {
                    path: "error-6",
                    name: "error-6",
                    component: () => import("@/view/pages/error/Error-6.vue")
                }
            ]
        },


        //  404
        {
            path: "*",
            redirect: "/404"
        },
        {
            // the 404 route, when none of the above matches
            path: "/404",
            name: "404",
            component: () => import("@/view/pages/error/Error-1.vue")
        }
    ]
});
